<div class="w-100" [ngClass]="{ 'position-relative' : options.defaultRelative  }">
    <input type="text" [ngClass]="options.classes" [ngModel]="vat" (keyup)="search($event)" (blur)="doneSearching()" autocomplete="dontUse">
    <div class="position-absolute w-100 flex-column bg-white border dawaResultContainer" *ngIf="searching" [ngStyle]="{
        'z-index' : options.zIndex
    }" [ngClass]="searching ? 'd-flex' : 'd-none'">
        <div class="d-flex flex-column gap-1 p-3" (click)="pickResult()">
            <div class="d-flex flex-between font-weight-bold">
                <div>{{ result.name }}</div>
                <div>{{ result.vat }}</div>
            </div>
            <div class="d-flex flex-column">
                <div class="d-flex align-items-center">{{ result.address }}</div>
                <div>{{ result.zipCode }} {{ result.city }}</div>
            </div>
        </div>
    </div>
</div>
